import React, { useState } from "react";
import api from "../axiosConfig";
export default function AiModulesPanel({ programId, onSaved }) {
  const [busy,setBusy] = useState(false);
  const [preview,setPreview] = useState(null);
  const [selected,setSelected] = useState([]);
  const [error,setError] = useState("");
  const [message,setMessage] = useState("");
  const generate = async () => {
    setBusy(true); setError(""); setMessage(""); setPreview(null);
    try { const {data} = await api.post(`/api/learning/programs/${programId}/suggest-modules`); setPreview(data); setSelected(data.modules.map((_,i)=>i)); }
    catch(e) {setError(e.response?.data?.error || "Could not research modules. Please retry.");}
    finally {setBusy(false);}
  };
  const save = async () => {
    setBusy(true); setError("");
    try { const {data} = await api.post(`/api/learning/programs/${programId}/modules/batch`,{modules:selected.map(i=>preview.modules[i]),sources:preview.sources}); setMessage(`Created ${data.created} modules. Skipped ${data.skipped} existing modules.`); setPreview(null); onSaved(); }
    catch(e) {setError(e.response?.data?.error || "Could not save modules. Please retry.");}
    finally {setBusy(false);}
  };
  return <section className="ai-modules-panel">
    <button type="button" className="action-button action-button-secondary" disabled={busy} onClick={generate}>{busy ? "Working…" : "Generate modules with AI"}</button>
    <p>Research the program title and preview modules with suggested lesson topics before saving.</p>
    {busy ? <p role="status">This may take a minute. Please keep this page open.</p> : null}
    {error ? <p role="alert">{error}</p> : null}
    {message ? <p role="status">{message}</p> : null}
    {preview ? <div><h3>Review proposed modules</h3><p>{preview.summary}</p>
      <div className="ai-module-sources"><strong>Research sources</strong>{preview.sources.map(s=><a key={s.url} href={s.url} target="_blank" rel="noreferrer">{s.title}</a>)}</div>
      {preview.modules.map((m,i)=><article className="ai-module-preview" key={m.title}><label><input type="checkbox" checked={selected.includes(i)} disabled={busy} onChange={e=>setSelected(v=>e.target.checked ? [...v,i] : v.filter(n=>n!==i))} /> {m.title}</label><p>{m.description}</p><ul>{m.lessonTopics.map(t=><li key={t}>{t}</li>)}</ul></article>)}
      <p>Saving creates modules only. Suggested lesson topics are kept in their descriptions.</p>
      <button type="button" className="action-button" disabled={busy || !selected.length} onClick={save}>Create selected modules ({selected.length})</button>
      <button type="button" className="action-link" disabled={busy} onClick={()=>setPreview(null)}>Cancel</button>
    </div> : null}
  </section>;
}
